import React from 'react';
import { Container, Typography } from 'amphitheatre';
import { Link } from 'react-router-dom';

const { Header } = Typography;

const Error404: React.FunctionComponent = () => {
  return (
    <Container className="content-container" size="lg">
      <Header>Oops!</Header>
      <Header level={4}>
        We can't seem to find the page you're looking for.
      </Header>
      <Header level={4}>
        <Link to="/">Click here</Link> to go back to the home page.
      </Header>
    </Container>
  );
};

export default Error404;
